import React, { useState, useEffect } from 'react';
import './summaryAnimation.css';


// interface TextRevealProps {
//   text: string,
//   delay?: number,
// }

// const TextReveal = ({ text, delay }:TextRevealProps) => {
//   return (
//     <div className="text-reveal">
//       {text.split('').map((char, index) => (
//         <span 
//           key={index} 
//           className="text-reveal-char"
//           style={{ animationDelay: `${delay}s` }}
//         >
//           {char}
//         </span>
//       ))}
//     </div>
//   );
// };

interface TextRevealProps {
  text: string;
  onComplete?: () => void;
  startDelay?: number;
}

const TextReveal: React.FC<TextRevealProps> = ({ text, onComplete, startDelay = 0 }) => {
  const [displayedText, setDisplayedText] = useState('');
  
  useEffect(() => {
    let currentIndex = 0;
    // Wait for startDelay before beginning
    const startTimeout = setTimeout(() => {
      const interval = setInterval(() => {
        if (currentIndex <= text.length) {
          setDisplayedText(text.slice(0, currentIndex));
          currentIndex++;
        } else {
          clearInterval(interval);
          onComplete?.();
        }
      }, 100);

      return () => clearInterval(interval);
    }, startDelay);

    return () => clearTimeout(startTimeout);
  }, [text, onComplete, startDelay]);

  return (
    <div className="text-reveal">
      {displayedText}
    </div>
  );
};


const TodoSummaryAnimation = ({ todos, onAnimationComplete }) => {
  const [showAnimation, setShowAnimation] = useState(true);
  const [currentPhase, setCurrentPhase] = useState(0);
  const [finishDisplay, setFinishDisplay] = useState(false);

  const completedTodos = todos.length;
  const totalTodos = todos.length;
  const [firstLineComplete, setFirstLineComplete] = useState(false);

  const finishAnimation = () => {
    setFinishDisplay(true);
    onAnimationComplete();
  };

  return (

    <div className={`animation-container ${finishDisplay? '-finish':''}`}>
        <div className='text-container'>
          {/* <TextReveal text="First line" delay={6}/>
          <TextReveal text="Second line" delay={7}/> */}
          <TextReveal text="Helllllllllooooo" startDelay={3000}/>
          <TextReveal text="I'm Bmo :)" startDelay={5000} onComplete={finishAnimation}/>
        </div>
    </div>
  );
};

export default TodoSummaryAnimation;